import regex from "../../regex";
const validateDeposito = (data) => {
  let issues = [];
  if (data.nome === undefined || data.nome === "")
    issues.push("Il campo 'nome' del tuo deposito è mancante o non valido.");
    if (data.piani === undefined || data.piani.length === 0)
      issues.push("Il campo 'Piani' del tuo deposito è mancante o non valido.");
  if (regex.uuid.test(data.comuneId) === false)
    issues.push("Il campo 'comune' del tuo deposito è mancante o non valido.");
  if (regex.uuid.test(data.organizationId) === false)
    issues.push("Il campo 'organizzazione' del tuo deposito è mancante o non valido.");
  if (data.piani?.some(piano => piano.scaffali?.some(scaffale => scaffale.nome === undefined || scaffale.nome === "")))
    issues.push("Il campo 'nome' di qualche scaffale è mancante o non valido.");
  return issues;
};

export default validateDeposito;
